// WelcomeModal.tsx

import React from 'react';
import Modal from 'ui/Modal'; // Adjust the import path as necessary

interface Props {
  open: boolean;
  onClose: () => void;
}

const WelcomeModal: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Modal isOpen={open} onClose={onClose} title="Welcome!">
      <div className="flex flex-col h-[calc(100%-44px)] max-h-[calc(100%-44px)] sm:h-auto overflow-y-scroll sm:overflow-y-auto">
        <div className="flex flex-col flex-grow prose dark:prose-invert space-y-1">
            {/* Content */}
            <p>
              Societea is a platform for identifying, discussing, and prioritizing social issues, their impacts, and potential
              solutions. Unlike other platforms, here, you can help build society's collective understanding of issues through structured discourse.
            </p>
            <p>
              <i>Spill the tea, read the leaves, or just have a sip.</i>
            </p>
            <div>
              <h4 className="font-semibold text-eoe-text-heading dark:text-eoe-dark-text-heading">
                How it works:
              </h4>
              <ul className="list-disc pl-5 space-y-1">
                <li>
                  Browse and search for <a href="/issues" className="external-link">issues</a>
                </li>
                <li>
                  View, discuss, and prioritize issues and their{' '}
                  <a href="/impacts" className="external-link">impacts</a> and proposed{' '}
                  <a href="/solutions" className="external-link">solutions</a>
                </li>
                <li>
                  Add new impacts and solutions for existing issues, or identify new issues
                </li>
              </ul>
            </div>
            <p>
              Please stay{' '}
              <a
                href="https://www.societea.io/policies/content-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="external-link"
              >
                passionate but respectful
              </a>
              , and feel free to share{' '}
              <a href="/user-feedback" className="external-link">feedback</a>.
            </p>
            <p className="text-left text-xs text-gray-600 dark:text-eoe-dark-text-meta pb-2">
                By continuing, you agree to our{' '}
                <a
                    href="https://www.societea.io/policies/user-agreement"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="external-link"
                >
                    User Agreement
                </a>{' '}
                and acknowledge that you understand the{' '}
                <a
                    href="/policies/privacy-policy"
                    className="external-link"
                >
                    Privacy Policy
                </a>
                . 
            <span className="text-left text-eoe-text-sub dark:text-eoe-dark-text-sub">
                &nbsp;We <i>never</i> sell or distribute your data.
            </span>
            </p>
          </div>
        {/* Actions */}
        <div className="flex flex-grow flex-col pb-4 justify-end place-items-end mb-4 mt-auto space-y-2 sm:space-y-0 sm:space-x-2 sm:flex sm:justify-end sm:flex-row sm:mb-0">
          <button className="btn-primary w-full sm:w-fit py-2 px-4" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
